import axiosInstance from "../../axios/axiosInstance";
import { BANNER_LISTING_URL, CREATE_BANNER_URL, DELETE_BANNER_URL, EDIT_BANNER_URL } from "../../constants";

export const createBanner = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_BANNER_URL, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const editBanner = (props) => onResponse => {

    try {
        axiosInstance.post(EDIT_BANNER_URL, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};



export const getBannerListing = (props) => onResponse => {
    try {
        let BASE_URL = BANNER_LISTING_URL
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const deleteBannerItem = (id) => onResponse => {

    try {
        axiosInstance.delete(DELETE_BANNER_URL, { data: { bannerId: id } })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};